document.querySelectorAll("path").forEach(function (path) {
  path.addEventListener("mouseover", function () {
    var region = this.getAttribute("data-region");

    // Usunięcie klasy active-click ze wszystkich ścieżek
    document.querySelectorAll("path").forEach(function (p) {
      p.classList.remove("active-click");
    });

    // Dodanie klasy active-click do najechanego regionu i powiązanych regionów
    document.querySelectorAll("div[data-regions]").forEach(function (div) {
      var regions = JSON.parse(div.getAttribute("data-regions"));

      if (regions.includes(region)) {
        div.classList.add("active");
        regions.forEach(function (activeRegion) {
          document
            .querySelectorAll('path[data-region="' + activeRegion + '"]')
            .forEach(function (p) {
              p.classList.add("active-click");
            });
        });
      } else {
        div.classList.remove("active");
      }
    });

    // Ukrycie div.contact-map__default
    document.querySelector(".contact-map__default").classList.add("hidden");
  });

  // Usunięcie zdarzenia mouseleave
});

document.addEventListener("click", function (event) {
  var isClickInsideContactMap = document
    .querySelector(".contact-map")
    .contains(event.target);

  if (!isClickInsideContactMap) {
    // Pokaż div.contact-map__default, jeśli kliknięcie jest poza .contact-map
    document.querySelector(".contact-map__default").classList.remove("hidden");

    // Resetuj stan aktywności mapy
    document.querySelectorAll("path").forEach(function (p) {
      p.classList.remove("active-click");
    });
    document.querySelectorAll("div[data-regions]").forEach(function (div) {
      div.classList.remove("active");
    });
  }
});

var mapLogo = document.querySelector(".map-logo");
mapLogo.addEventListener("mouseenter", function () {
  console.log("tt");
  document.querySelector(".contact-map__default").classList.remove("hidden");
});
